import { useEffect, useState } from 'react';
import { getAccessTokenApi } from 'api/auth';
import { getPdfTemplateByTypeApi, getPdfTemplateByTypeAdminApi } from 'api/pdfTemplate';

/**
 * Hook que carga una plantilla PdfTemplate por documentType.
 * Si se provee `tenantId` (uso del super-tenant via /admin/tenants/:tenantId/...),
 * llama al endpoint admin scoped; sino al endpoint base (tenant del token).
 * Retorna { template, loading, error }. Si el fetch falla o no hay plantilla,
 * `template` queda en null y el caller puede renderizar su fallback.
 */
export default function useTemplateOrFallback(documentType, tenantId) {
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await getAccessTokenApi();
        const result = tenantId
          ? await getPdfTemplateByTypeAdminApi(token, tenantId, documentType)
          : await getPdfTemplateByTypeApi(token, documentType);
        if (cancelled) return;
        if (result?.status === 'client') {
          setError(result.message);
          setTemplate(null);
        } else {
          setTemplate(result || null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setTemplate(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [documentType, tenantId]);

  return { template, loading, error };
}
